"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSectionList = createSectionList;
const createComorbidities_1 = require("./createComorbidities");
const createCurrentCardiologicalState_1 = require("./createCurrentCardiologicalState");
const createLabProcedures_1 = require("./createLabProcedures");
const createMedicalHistory_1 = require("./createMedicalHistory");
const createMicrobiologicalProcedures_1 = require("./createMicrobiologicalProcedures");
const createRisks_1 = require("./createRisks");
const createScreeningProcedures_1 = require("./createScreeningProcedures");
const createSensitization_1 = require("./createSensitization");
const createVaccinationStatus_1 = require("./createVaccinationStatus");
function createSectionList(intl, options) {
    return [
        (0, createMedicalHistory_1.createMedicalHistory)(intl, options),
        (0, createCurrentCardiologicalState_1.createCurrentCardiologicalState)(intl, options),
        (0, createComorbidities_1.createComorbidities)(intl, options),
        (0, createScreeningProcedures_1.createScreeningProcedures)(intl, options),
        (0, createLabProcedures_1.createLabProcedures)(intl, options),
        (0, createSensitization_1.createSensitization)(intl, options),
        (0, createMicrobiologicalProcedures_1.createMicrobiologicalProcedures)(intl, options),
        (0, createVaccinationStatus_1.createVaccinationStatus)(intl, options),
        (0, createRisks_1.createRisks)(intl, options)
    ];
}
